import { NextSeo } from 'next-seo';
import { FC } from 'react';

import { IUrlQueryStringParams } from '@/components/PostEvent/GroupSelect';
import { StringParam, useQueryParams } from '@/hooks/useQueryParams';
import { useResource } from '@/lib/datx-jsonapi-react';
import { queryThinEvent } from '@/queries/thin-events';

export interface IEventsPageSeoParams {
  page: string;
}

export const EventsPageSeo: FC<IEventsPageSeoParams> = ({ page }) => {
  const { eventId } = useQueryParams<IUrlQueryStringParams>({
    eventId: StringParam,
  });

  const { data: event } = useResource(queryThinEvent(eventId));

  return (
    <NextSeo
      title={event?.name}
      openGraph={{
        url: `${process.env.NEXT_PUBLIC_BASE_URL}events/${event?.id}/${page}`,
        title: event?.name,
        description: event?.description,
        images: [
          {
            url: event?.mediumHeaderImageUrl || `${process.env.NEXT_PUBLIC_BASE_URL}images/landing/hero-share.jpg`,
            width: 800,
            height: 600,
            alt: `Photo - ${event?.name}`,
          },
        ],
      }}
    />
  );
};
